var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_keyboard_arrow_left_24px","d":"M14.175,14.325,10.358,10.5l3.817-3.825L13,5.5l-5,5,5,5Z","transform":"translate(-5.5 14.175) rotate(-90)"}));
}

ChevronDown.defaultProps = {"width":"10","height":"6.175","viewBox":"0 0 10 6.175"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
